class PageVN {
	constructor (options) {
		this.option = options;
		this.addEventListeners();
	}

	/**
	 * Called when the "I live in" country select is changed
	 * Changes the VN description message ( commented until we have values/translations for the IN_COUNTRY_* variables. Only a few are present. )
	 *
	 * @return {boolean}
	 */

	static change_forwardTo() {
		let _this = self;
		let forward_select = $(_this.option.forward_to);
		let selected_country = forward_select.val();
		let vn_countries = $(_this.option.vn_countries);
		let forward_response = $(_this.option.forward_response);
		PageVN.changeMessage(
			forward_select.find('option:selected').data('placeholderVar'),
			$(_this.option.country_select)
				.find('option:selected')
				.data('placeholderVar')
		);
		if (vn_countries[0].mobile || vn_countries[0].fixed) {
			for (let i = 0;i < vn_countries[0].mobile.length;i++) {
				if (vn_countries[0].mobile[i] === selected_country) {
					forward_response.html(s.it('VN_CAN_BE_FORWARDED'));
				}
			}
			for (let j = 0;j < vn_countries[0].fixed.length;j++) {
				if (vn_countries[0].fixed[j] === selected_country) {
					forward_response.html(s.it('VN_CAN_BE_FORWARDED_LANDLINE'));

					return -1;
				}
			}

			return true;
		}

		return false;
	}

	static setAjax (url, data) {
		return new Promise(function (resolve, reject) {
			$.ajax({
				'method' : 'POST',
				'url' : url,
				'data' : data,
				success : function (response) {
					resolve(response);
				},
				error : function (response) {
					reject(response);
				}
			});
		});
	}

	static populateSelect (selector, data, code_selector) {
		let options = `<option value=''>${s.it('SELECT_ONE')}</option>`;
		let select = $(selector);
		for (let i = 0;i < data.length;i++) {
			options += `<option value='${data[i].id}' data-id='${data[i].id}'>${data[i].name} [${data[i][code_selector]}]</option>`;
		}
		select.html(options);
		select.removeClass('d-none');
	}

	/**
	 * Called when the "My friends live in" select is changed
	 * Populates the state/area selector for that country
	 *
	 */

	getStates () {
		let _this = self;
		let spinner = $(_this.option.spinner);
		let form_product_id = $(_this.option.form_product_id);
		let form_country_code = $(_this.option.form_country_code);
		let vn_not_available = $(_this.option.vn_not_available);

		PageVN.changeMessage(
			$(_this.option.forward_to)
				.find('option:selected')
				.data('placeholderVar'),
			$(_this.option.country_select)
				.find('option:selected')
				.data('placeholderVar')
		);
		PageVN.changeMapFlag(
			$(_this.option.country_select)
				.find('option:selected')
				.attr('data-country-code')
		);

		$(_this.option.state_select)
			.find('option')
			.remove();
		$(_this.option.state_select).addClass('d-none');
		$(_this.option.area_select)
			.find('option')
			.remove();
		$(_this.option.area_select).addClass('d-none');

		if (!vn_not_available.hasClass('d-none')) {
			vn_not_available.addClass('d-none');
		}

		let data = {
			'action' : 'get_states',
			'country_id' : $(_this.option.country_select).val()
		};
		const country_select = document.getElementById('country_select');
		const country_name = country_select?.options[country_select.selectedIndex].dataset.country_name;
		const new_url = s.url(`/buy/virtual_number/${encodeURIComponent(country_name)}`);
		window.history.replaceState({}, '', new_url);
		spinner.removeClass('d-none');
		PageVN.setAjax(s.url('/process_vn'), data).then(data => {
			_this.handleContinue();
			if (data.states.length !== 0) {
				PageVN.populateSelect(_this.option.state_select, data.states, 'code');
			} else if (data.areas.length !== 0) {
				PageVN.populateSelect(_this.option.area_select, data.areas, 'area_code');
			} else if (data.states.length === 0 && data.areas.length === 0) {
				vn_not_available.removeClass('d-none');
			}
			spinner.addClass('d-none');
		});
		form_product_id.val(
			$(this)
				.find('option:selected')
				.attr('data-product_id')
		);
		form_country_code.val(
			$(this)
				.find('option:selected')
				.attr('data-country-code')
		);
	}

	/**
	 * Populates the area selector for a specific county/state
	 */

	getAreas () {
		let _this = self;
		let spinner = $(_this.option.spinner);
		let continue_btn = $(_this.option.continue);
		let data = {
			'action' : 'get_areas',
			'country_id' : $(_this.option.country_select).val(),
			'state_id' : $(_this.option.state_select).val()
		};
		spinner.removeClass('d-none');
		PageVN.setAjax(s.url('/process_vn'), data).then(data => {
			if (data.length > 0) {
				_this.handleContinue();
				s.track.dataLayerPush(_this.pushToDataLayer());
				PageVN.populateSelect(_this.option.area_select, data, 'area_code');
				spinner.addClass('d-none');
			}
		});
	}

	pushToDataLayer() {
		return {
			'event' : 'gtm_custom_event',
			'target_country' : s.trim($(this.option.forward_to).text()),
			'destination' : s.trim($(this.option.country_select).text()),
			'currency' : s.options.currency.code
		};
	}

	static changeMapFlag(country_code) {
		let _this = self;
		let flag = $('.' + _this.option.flag);
		flag.removeClass();
		flag.addClass(_this.option.flag);
		flag.addClass('flag-' + country_code.toUpperCase());
		flag.attr('country-code', country_code.toUpperCase());
	}

	static changeMessage(me, parents) {
		// commented until we have values/translations for the IN_COUNTRY_* variables. Only a few are present.
		//let _this = self;
		//$(_this.option.message).html(s.it('VN_DESCRIPTION_NEW', {'i_live_in' : s.trim(me), 'parents_live_in' :  $.trim(parents)}));
	}

	addEventListeners () {
		window.self = this;
		let forward_select = $(window.self.option.forward_to);
		let country_select = $(window.self.option.country_select);
		let state_select = $(window.self.option.state_select);
		let area = $(window.self.option.area_select);
		forward_select.on('change', PageVN.change_forwardTo);
		country_select.on('change', this.getStates);
		state_select.on('change', this.getAreas);
		area.on('change', this.handleContinue);
		forward_select.trigger('change');
		//country_select.trigger('change');
	}

	handleContinue() {
		let _this = self;
		let continue_button = $(_this.option.continue);
		let area = $(_this.option.area_select + ' option:selected').data('id');
		if (typeof area === 'undefined') {
			continue_button.prop('disabled', true);

			return false;
		}
		continue_button.prop('disabled', false);

		return true;
	}
}
